import Checkbox from "../../../shared/ui/Field/Checkbox";

// NotificationPreferenceField — leaf view for one preference row.
// Selector-free, dispatch-free; consumes its data via props only.
// Thin feature-local wrapper around the Checkbox primitive that adds
// the row spacing slot. Kept separate from the widget per
// migration/phase8-form-plan.md §7.2 "split during transcription".

function NotificationPreferenceField({
  name,
  label,
  description,
  checked,
  disabled = false,
  onToggle,
}) {
  const handleChange = (event) => {
    if (!onToggle) return;
    onToggle(name, event.target.checked);
  };

  return (
    <div className="feature-notification-preferences__row">
      <Checkbox
        id={`pref-${name}`}
        name={name}
        label={label}
        description={description}
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
      />
    </div>
  );
}

export default NotificationPreferenceField;
